import { errorReason, isHtmlPage, validationText } from '../errors/index';

/* eslint-disable @typescript-eslint/no-explicit-any -- тело отказа — что прислал сервер: разбор по полям, как у
   интерцептора Front до ядра */

/**
 * Причина отказа из тела ответа 400–599 — массивом строк, как его разбирают `catch` приложений (форма интерцептора
 * Front до ядра): `InnerExceptions` (сообщения элементов), `errors` (`Message` или осмысленный `title` и сообщения
 * валидации — без имён полей и `title` по умолчанию), `message`
 * (+ `innerException.Message`/`message`), `Message`, `title`, строка, ArrayBuffer. Страница ошибки прокси вместо
 * строки — `pageFallback` (текст общего тоста). undefined — тело причины не содержит (пустое, Blob, без полей): тогда
 * клиент отдаёт текст неизвестного отказа.
 */
export function failureBodyLines(data: unknown, pageFallback: string): string[] | undefined {
    if (data === null || data === undefined) return undefined;
    const body = data as any;

    if (body.InnerExceptions) {
        const lines: string[] = [];
        (body.InnerExceptions as any[]).forEach((inner) => {
            if (inner?.message) lines.push(inner.message);
            else if (inner?.Message) lines.push(inner.Message);
        });
        if (lines.length > 0) return lines;
    } else if (body.errors) {
        if (body.Message !== undefined) {
            if (body.Message) return [body.Message];
        } else {
            const validation = validationText(body.errors);
            if (validation) return [errorReason(body.title), validation].filter((line): line is string => !!line);
        }
    }

    if (body.message !== undefined) {
        if (body.innerException?.Message !== undefined) return [body.message, body.innerException.Message];
        if (body.innerException?.message !== undefined) return [body.message, body.innerException.message];
        return [body.message];
    }
    if (body.Message !== undefined) return [body.Message];
    if (body.title !== undefined) return [body.title];

    if (typeof data === 'string') return [isHtmlPage(data) ? pageFallback : data];
    if (data instanceof ArrayBuffer) {
        const text = new TextDecoder().decode(data);
        return [isHtmlPage(text) ? pageFallback : text];
    }
    return undefined;
}
